var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TOOL_TYPE } from '@syllepsis/editor';
import React from 'react';
import { MoreForToolbar } from './tools';
import { ButtonForToolbar } from './tools/button';
import { Divider } from './tools/divider';
import { SelectForToolbar } from './tools/select';
var noop = function () { };
var ToolDisplay;
(function (ToolDisplay) {
    ToolDisplay["HORIZON"] = "horizon";
    ToolDisplay["VERTICAL"] = "vertical";
})(ToolDisplay || (ToolDisplay = {}));
// check whether the content all include the format
var checkFormatAcross = function (editor, formatName) {
    var hasFormat = true;
    var isTable = false;
    var isNode = Boolean(editor.view.state.schema.nodes[formatName]);
    editor.nodesBetween(function (node) {
        // if none, the format should be apply
        if (!hasFormat)
            return false;
        if (node.type.spec.tableRole)
            isTable = true;
        if (isTable)
            return false;
        // only care about the top node when isNode format
        if (isNode && node.isBlock && !node.type.spec.isolating) {
            hasFormat = node.type.name === formatName;
            return false;
        }
        else if (node.isText) {
            hasFormat = node.marks.some(function (mark) { return mark.type.name === formatName; });
        }
    });
    return isTable || hasFormat;
};
var getGroupKey = function (data) { return data.content.map(function (i) { return i.name; }).join('|'); };
var getToolDisplay = function (type) { return (type ? ToolDisplay.HORIZON : ToolDisplay.VERTICAL); };
// click event of button. `handler` provided by `controller` is prefer. (default is `setFormat`)
var getHandler = function (toolbar, callback) { return function (editor, name, attrs) {
    var _a;
    if (!toolbar || !name)
        return noop;
    if (toolbar.handler) {
        toolbar.handler(editor, name, attrs);
    }
    else {
        // need to check whether the content all include the format when `attrs` is false and format activated
        editor.setFormat((_a = {},
            _a[name] = attrs ? attrs : editor.isActive(name) ? (checkFormatAcross(editor, name) ? false : true) : attrs,
            _a));
    }
    callback && callback(editor, name);
}; };
var stamp = 1;
var uuid = function () { return "" + stamp++; };
var renderSylButton = function (_a) {
    var activeFormat = _a.activeFormat, content = _a.content, editor = _a.editor, option = _a.option, depth = _a.depth, toolbarType = _a.toolbarType, selectProps = _a.selectProps, buttonProps = _a.buttonProps, _b = _a.extra, extra = _b === void 0 ? {} : _b;
    var _c = content.name, name = _c === void 0 ? '' : _c, type = content.type, toolbar = content.toolbar, tooltip = content.tooltip, showName = content.showName;
    var onToolClick = option.onToolClick, tipDirection = option.tipDirection, tipDistance = option.tipDistance, menuDirection = option.menuDirection, menuDistance = option.menuDistance;
    var active = Boolean(activeFormat[name]);
    var prop = {
        name: name,
        toolbar: toolbar,
        editor: editor,
        showName: showName,
        active: active,
        tooltip: tooltip,
        toolbarType: toolbarType,
        tipDirection: tipDirection,
        tipDistance: tipDistance,
        attrs: active ? activeFormat[name] : false,
        display: getToolDisplay(depth),
        handler: getHandler(toolbar, onToolClick),
    };
    var trigger = option.trigger;
    if (toolbar) {
        if (toolbarType === 'inline' && toolbar.inline && toolbar.inline.trigger) {
            trigger = toolbar.inline.trigger;
        }
        else if (toolbar.trigger) {
            trigger = toolbar.trigger;
        }
    }
    var groupKey = extra.groupKey, config = extra.config;
    switch (type) {
        case TOOL_TYPE.DIVIDER:
            return React.createElement(Divider, { key: uuid() });
        case TOOL_TYPE.SELECT:
        case TOOL_TYPE.DROPDOWN:
            return (React.createElement(SelectForToolbar, __assign({ key: type + "-" + name, trigger: trigger, type: type, menuDirection: menuDirection, menuDistance: menuDistance, groupKey: groupKey }, prop, selectProps, config)));
        case TOOL_TYPE.BUTTON:
        default:
            return React.createElement(ButtonForToolbar, __assign({ key: "button-" + name }, prop, buttonProps, config));
    }
};
// render content of dropdown
var renderMoreToolButton = function (_a) {
    var editor = _a.editor, renderMenu = _a.renderMenu, option = _a.option, content = _a.content, toolbarType = _a.toolbarType, groupKey = _a.groupKey, depth = _a.depth;
    var menuDistance = option.menuDistance, menuDirection = option.menuDirection, trigger = option.trigger, tipDirection = option.tipDirection, tipDistance = option.tipDistance;
    var icon = content.icon, contentItems = content.content, tooltip = content.tooltip, _b = content.name, name = _b === void 0 ? '' : _b, cTrigger = content.trigger;
    return (React.createElement(MoreForToolbar, { trigger: cTrigger || trigger, key: uuid(), toolbarType: toolbarType, name: name, icon: icon, editor: editor, 
        // @ts-ignore
        key: name || groupKey, display: getToolDisplay(depth), tooltip: tooltip, menuDistance: content.menuDistance || menuDistance, groupKey: groupKey, menuDirection: content.menuDirection || menuDirection, tipDirection: content.tipDirection || tipDirection, tipDistance: content.tipDistance || tipDistance, renderMenu: function () { return renderMenu(contentItems, depth); } }));
};
export { getGroupKey, getHandler, getToolDisplay, noop, renderMoreToolButton, renderSylButton, ToolDisplay, uuid, };
//# sourceMappingURL=utils.js.map